/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsEDRMachineOSCount
 */
export interface JumboStructsEDRMachineOSCount {
    /**
     * 
     * @type {number}
     * @memberof JumboStructsEDRMachineOSCount
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsEDRMachineOSCount
     */
    osName?: string;
}

/**
 * Check if a given object implements the JumboStructsEDRMachineOSCount interface.
 */
export function instanceOfJumboStructsEDRMachineOSCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRMachineOSCountFromJSON(json: any): JumboStructsEDRMachineOSCount {
    return JumboStructsEDRMachineOSCountFromJSONTyped(json, false);
}

export function JumboStructsEDRMachineOSCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRMachineOSCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'osName': !exists(json, 'osName') ? undefined : json['osName'],
    };
}

export function JumboStructsEDRMachineOSCountToJSON(value?: JumboStructsEDRMachineOSCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'osName': value.osName,
    };
}

